import { styled } from "@mui/system";

export const ContainerSeekAndFind = styled('div')`
    max-width: 50%;
    margin: auto;
`;
